<template>
  <div>
    <loading :loading="loading" />
    <form v-if="!loading" action="" class="md-layout" @submit.prevent="submit">
      <div class="md-layout-item">
        <md-card-header>
          <div class="md-title">{{ buttomText }} Sensor Virtual</div>
        </md-card-header>
        <md-card-content>
          <md-field :class="getValidationClass('titulo')">
            <label for="titulo">Titulo</label>
            <md-input id="titulo" v-model="form.titulo" />
            <span v-if="!$v.form.titulo.required" class="md-error"
              >Titulo é obrigatório</span
            >
          </md-field>

          <md-field :class="getValidationClass('descricao')">
            <label for="descricao">Descrição</label>
            <md-input id="descricao" v-model="form.descricao" />
            <span v-if="!$v.form.descricao.required" class="md-error"
              >Descrição é obrigatória</span
            >
          </md-field>

          <sensor-autocomplete
            id="sensores"
            v-model="form.sensorId"
            name="sensores"
            :local-id="localId"
            :validation="$v.form.sensorId"
          />

          <div class="md-layout">
            <div class="md-layout-item">
              <md-field :class="getValidationClass('expressao')">
                <label for="expressao">Expressão</label>
                <md-input id="expressao" v-model="form.expressao" />
                <span v-if="!$v.form.expressao.required" class="md-error"
                  >Expressão é obrigatória</span
                >
              </md-field>
            </div>

            <div class="md-layout-item">
              <md-button class="md-primary mt-3" @click="consultar">
                Consultar
              </md-button>
            </div>

            <div class="md-layout-item">
              <span class="md-title">Funções</span>
              <div style="display: grid; grid-template-columns: repeat(3, 1fr)">
                <div v-for="funcao in funcoes" :key="funcao.nome" class="p-1">
                  <span class="md-list-item-text">{{ funcao.nome }}</span>
                  <md-tooltip md-direction="left">
                    {{ funcao.descricao }}
                  </md-tooltip>
                </div>
              </div>
            </div>
          </div>

          <md-switch
            id="persistencia"
            v-model="form.persistencia"
            :disabled="isEdit"
          >
            <span>Persistência </span>
            <span class="md-caption"
              >(persiste o resultado da expressao a cada valor que o sensor
              recebe)</span
            >
          </md-switch>

          <md-switch
            v-if="form.persistencia"
            id="visibilidadeGrafico"
            v-model="form.visibilidadeGrafico"
          >
            <span>Visibilidade Gráfico</span>
          </md-switch>

          <br />

          <md-switch
            id="exibirPainelEquipamento"
            v-model="form.exibirPainelEquipamento"
          >
            <span>Exibir no painel do equipamento</span>
          </md-switch>

          <md-field :class="getValidationClass('periodoTipo')">
            <label for="periodoTipo">Tipo de período</label>
            <md-select v-model="form.periodoTipo" :disabled="isEdit">
              <md-option :value="0"> Nenhum </md-option>
              <md-option :value="1"> Turno </md-option>
              <md-option :value="2"> Ultimas horas </md-option>
              <md-option :value="3"> Mensal </md-option>
            </md-select>
            <span v-if="!$v.form.periodoTipo.required" class="md-error"
              >Tipo de período é obrigatório</span
            >
          </md-field>

          <sensor-virtual-periodo
            :periodo-tipo="form.periodoTipo"
            :periodo-value="form.periodoValue"
            :local-id="localId"
            @change="onChangePeriodo"
          />

          <div class="botoes">
            <md-button
              class="md-raised md-accent"
              @click.prevent="$router.back()"
            >
              Voltar
            </md-button>
            <md-button type="submit" class="md-raised md-primary">
              {{ buttomText }}
            </md-button>
            <md-progress-spinner
              v-if="loading"
              :md-diameter="40"
              :md-stroke="5"
              md-mode="indeterminate"
            />
          </div>
        </md-card-content>
      </div>
    </form>

    <md-dialog :md-active.sync="consultarExpressao">
      <div class="p-4" style="width: 60vw; height: 70vh">
        <span class="md-title">Consultar Expressão</span>
        <consultar-expressao
          :expressao="form.expressao"
          :sensor-id="form.sensorId"
          @close="consultarExpressao = false"
        />
      </div>
    </md-dialog>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import SensorAutocomplete from '@/components/autocomplete/SensorAutocomplete.vue'
import Loading from '@/components/Loading.vue'
import ConsultarExpressao from '@/components/sensor-virtual/ConsultarExpressao.vue'
import SensorVirtualPeriodo from '@/components/sensor-virtual/SensorVirtualPeriodo.vue'
import { EventBus, Topics, Types } from '@/event-bus'

import http from '../../utils/http'

export default {
  name: 'SensorVirtualInput',
  components: {
    Loading,
    ConsultarExpressao,
    SensorVirtualPeriodo,
    SensorAutocomplete,
  },
  mixins: [validationMixin],
  data() {
    return {
      sensorVirtualId: null,
      form: {
        sensorId: null,
        titulo: '',
        descricao: '',
        expressao: '',
        persistencia: false,
        exibirPainelEquipamento: false,
        periodoTipo: 0,
        visibilidadeGrafico: false,
        periodoValue: null,
      },
      localId: null,
      loading: false,
      opened: false,
      funcoes: [],
      consultarExpressao: false,
    }
  },
  validations: {
    form: {
      titulo: { required },
      descricao: { required },
      sensorId: { required },
      expressao: { required },
      persistencia: { required },
      periodoTipo: { required },
      visibilidadeGrafico: { required },
    },
  },
  computed: {
    isEdit() {
      return !!this.sensorVirtualId
    },
    buttomText() {
      return this.isEdit ? 'Editar' : 'Cadastrar'
    },
  },
  async beforeMount() {
    this.localId = this.$route.params.localId

    this.sensorVirtualId = this.$route.params.sensorVirtualId

    http.get(`sensor/virtual/funcoes`).then((response) => {
      this.funcoes = response.funcoes
    })

    if (this.sensorVirtualId) {
      this.loading = true
      http
        .get(`sensor/virtual/${this.sensorVirtualId}`)
        .then((response) => {
          this.form = response.sensorVirtual
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  methods: {
    consultar() {
      if (!this.form.sensorId) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.WARNING,
          message: 'Selecione um sensor',
        })
        return
      }

      this.consultarExpressao = true
    },
    onChangePeriodo(data) {
      this.form.periodoValue = data
    },
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName]
      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty,
        }
      }
    },
    async submit() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      if (this.form.periodoValue === null) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.WARNING,
          message: 'Periodo é inválido',
        })
        return
      }

      this.loading = true

      if (this.isEdit) {
        await http.put(`sensor/${this.form.sensorId}/virtual`, {
          ...this.form,
          localId: this.localId,
          sensorVirtualId: this.sensorVirtualId,
        })
      } else {
        const response = await http.post(
          `sensor/${this.form.sensorId}/virtual`,
          {
            ...this.form,
            localId: this.localId,
          }
        )

        if (response) {
          this.$router.back()
        }
      }

      this.loading = false
    },
  },
}
</script>

<style scoped></style>
